
























































































































































































import { Component, Vue, Emit, Prop, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { maskMoney, maskCPFCNPJ, maskDateTime } from '@/utils/common'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentModalMultiplasNotasFiscais extends Vue {
  @Prop({ required: true, default: false }) disabled: boolean

  loadEditar = ''
  modalDeleteNotaFiscal = false

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get headers() {
    return [
      { text: 'Nome do arquivo', value: 'nomeArquivoOriginal', align: 'center' },
      { text: 'Data recebimento', value: 'dataRecebimentoNota', align: 'center' },
      { text: 'Número da nota', value: 'numeroNota', align: 'center' },
      { text: 'Valor da nota', value: 'valorNotaFiscal', align: 'center' },
      { text: 'Situação', value: 'situacao', align: 'center' },
      { text: 'Criado por', value: 'createdByNome', align: 'center' },
      { text: 'Data criação', value: 'createdOn', align: 'center' },
      { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
    ]
  }

  get loadingEditar() {
    return this.loadEditar
  }

  set loadingEditar(value: string) {
    this.loadEditar = value
  }

  get showModalDeleteNotaFiscal() {
    return this.modalDeleteNotaFiscal
  }

  set showModalDeleteNotaFiscal(value: boolean) {
    this.modalDeleteNotaFiscal = value
  }

  get showModalAtualizarNotaFiscal() {
    return this.getFinanceiroStore.modal.multiplasNotasFiscais
  }

  get prestadorRecebimento() {
    return this.getFinanceiroStore.prestadorRecebimento
  }

  formatMoneyUtil(money: any) {
    return maskMoney(money)
  }

  formatDateTimeUtil(date: string) {
    return maskDateTime(date)
  }

  maskCPFCNPJUtil(value: string) {
    return maskCPFCNPJ(value)
  }

  closeModal() {
    this.getFinanceiroStore.setModal({ name: 'multiplasNotasFiscais', value: false })
  }

  openModalDeleteNotaFiscal(id: string) {
    this.getFinanceiroStore.setIdForDeleteNotaFiscal(id)
    this.showModalDeleteNotaFiscal = true
  }

  async deleteNotaFiscal() {
    const response = await this.getFinanceiroStore.deleteNotaFiscal()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nota fiscal excluída com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getFinanceiroStore.geRecebimentoById(this.getFinanceiroStore.prestadorRecebimento.id)
      this.showModalDeleteNotaFiscal = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao excluir a nota fiscal.', icon: 'warning', color: '#C62828' })
    }
  }

  async editar(item: any) {
    this.loadingEditar = item.id
    if (item.nomeArquivoOriginal) {
      this.getFinanceiroStore.setDisabledConfirmar(true)
    }
    this.getFinanceiroStore.setIsNewNotaFiscal(true)
    this.getFinanceiroStore.setNotaFiscalItem(item)
    this.getFinanceiroStore.setModal({ name: 'editarNotaFiscal', value: true })
    this.loadingEditar = ''
  }

  novaNotaFiscal() {
    this.getFinanceiroStore.setModal({ name: 'editarNotaFiscal', value: true })
  }
}
